import React, { useState } from 'react';
import { X, Monitor, Calendar, Link } from 'lucide-react';

const LinkScreenModal = ({ isOpen, onClose, onSubmit, screen, events }) => {
  const [selectedEventId, setSelectedEventId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedEventId) {
      setError('Debes seleccionar un evento');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onSubmit(screen.id, selectedEventId);
      setSelectedEventId('');
    } catch (error) {
      setError('Error al vincular la pantalla');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setSelectedEventId('');
      setError('');
      onClose();
    }
  };

  if (!isOpen || !screen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Vincular Pantalla</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            disabled={loading}
          >
            <X size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          {/* Información de la Pantalla */}
          <div className="card p-4">
            <h3 className="font-medium text-gray-900 mb-3">Pantalla a Vincular</h3>
            <div className="flex items-center space-x-3">
              <Monitor size={20} className="text-blue-600" />
              <div>
                <div className="font-medium text-gray-900">{screen.name}</div>
                <div className="text-sm text-gray-600">{screen.location}</div>
                <div className="text-xs text-gray-500">Código: {screen.code}</div>
              </div>
            </div>
          </div>

          {/* Selección de Evento */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Seleccionar Evento
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Calendar size={16} className="text-gray-400" />
                </div>
                <select
                  value={selectedEventId}
                  onChange={(e) => setSelectedEventId(e.target.value)}
                  className="input-field pl-10"
                  required
                  disabled={loading}
                >
                  <option value="">Selecciona un evento...</option>
                  {events.length === 0 && (
                    <option value="" disabled>No hay eventos disponibles</option>
                  )}
                  {events.map((event) => (
                    <option key={event.eventId || event.id} value={event.eventId || event.id}>
                      {event.name} - {event.date ? (event.date.toDate ? new Date(event.date.toDate()).toLocaleDateString() : new Date(event.date).toLocaleDateString()) : 'Fecha no definida'}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {selectedEventId && (
              <div className="card p-4 bg-blue-50 border-blue-200">
                <h4 className="font-medium text-blue-900 mb-2">Evento Seleccionado</h4>
                {(() => {
                  const selectedEvent = events.find(e => (e.eventId || e.id) === selectedEventId);
                  if (!selectedEvent) return null;
                  
                  return (
                    <div className="space-y-2 text-sm text-blue-800">
                      <div><strong>Nombre:</strong> {selectedEvent.name}</div>
                      <div><strong>Fecha:</strong> {selectedEvent.date ? (selectedEvent.date.toDate ? new Date(selectedEvent.date.toDate()).toLocaleDateString() : new Date(selectedEvent.date).toLocaleDateString()) : 'No definida'}</div>
                      <div><strong>Ubicación:</strong> {selectedEvent.location || 'No definida'}</div>
                      <div><strong>Estado:</strong> {selectedEvent.status}</div>
                    </div>
                  );
                })()}
              </div>
            )}

            {error && (
              <div className="text-red-600 text-sm bg-red-50 p-3 rounded-md">
                {error}
              </div>
            )}

            <div className="flex space-x-3 pt-4">
              <button
                type="button"
                onClick={handleClose}
                className="btn-secondary flex-1"
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading || !selectedEventId}
                className="btn-primary flex-1"
              >
                {loading ? 'Vinculando...' : (
                  <>
                    <Link size={16} className="mr-2" />
                    Vincular Pantalla
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LinkScreenModal;
